
import React, { Component } from 'react';
import './archive.scss'
import { Modal, ModalBody } from "reactstrap";
import { ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'

class AssignmentDeletionComponent extends Component {

    onClickDelete = () => {

        if(this.props.isAssignPractice === true) {
            this.props.delegate.onClickDelete && this.props.delegate.onClickAssignClickerPractice(this.props.selectedItem)
        }else {
            this.props.delegate.onClickDelete && this.props.delegate.onClickDelete(this.props.selectedItem)
        }

        
    }

    onCLickCancel = () => {
        this.props.onClose && this.props.onClose()
    }

    render() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.props.onClose} size={this.props.size || 'md'}>

                <ModalBody >
                    <div className="archive-modal">
                        <div className="row">
                            <div className="col">
                                <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                            </div>
                        </div>

                        <div className="text-center">
                            <div className="title">{this.props.title || "Are you sure you want to Delete this item?"}</div>
                        </div>

                        <div className="text-center py-4">
                            <button className="cw-button-primary light mr-2" onClick={this.onCLickCancel}>
                                Cancel
                                </button>
                            <button className="cw-button-primary" onClick={this.onClickDelete}>
                                {this.props.isAssignPractice === true ? 'Clone' : 'Delete'}
                            </button>
                        </div>
                    </div>
                </ModalBody>
            </Modal >
        );
    }
}

export default AssignmentDeletionComponent;